import React from 'react';
import FilterSidebar from './FilterSidebar';
import Price from './fields/Price';
import Tags from './fields/Tags';
import Categories from './fields/Categories';
import Fulltext from './fields/Fulltext';
import DateRangePicker from './fields/DateRangePicker';
import Radius from './fields/Radius';
import TagDropdown from './fields/TagDropdown';

const EventsFilter = ({categories, tags, onSubmit, filter, fixedFilter}) => (
    <FilterSidebar
        forListing="events"
        filters={{
            'fulltext': <Fulltext selected={filter.fulltext} />,
            'radius': <Radius selected={filter.radius} />,
            'date': <DateRangePicker
                selectedStartDate={filter.end_date_from}
                selectedEndDate={filter.start_date_to}
            />,
            'categories': <Categories
                categories={categories}
                selected={filter.categories}
                fixed={fixedFilter.categories}
            />,
            'tagDropdown': <TagDropdown selected={filter.tags} />,
            'price': <Price selected={filter.price_amount_to} />,
            'tags': <Tags tags={tags} selected={filter.tags} fixed={fixedFilter.tags} />,
        }}
        hiddenFilters={{
            // Filter values used by the predefined filters coming from the backend that we don't show in our normal
            // filter form. They get added as hidden fields so they are preserved when changing the filter values.
            'is_highlight': filter.is_highlight,
            'hosts': filter.hosts,
            'locations': filter.locations,
            'parent_event': filter.parent_event,
            'tags_id': filter.tags_id,
        }}
        onSubmit={onSubmit}
    />
);

export default EventsFilter;
